import { Guid, Nillable } from '@web/utils';
import { AdminOrderBillingAddress } from './admin-order-billing-address';
import {
  OrderNumber,
  OrderRefundCollectionItem,
  OrderStatus,
  RefundSummary,
} from '@web/shared/module/shop';
import { AdminOrderItem } from './admin-order-item';
import { AdminOrderPayment } from './admin-order-payment';
import { AdminOrderShipment } from './admin-order-shipment';
import { AdminOrderInvoice } from './admin-order-invoice';
import { AdminOwner } from './admin-owner';

export class AdminOrderDetails {
  public constructor(
    private readonly data: {
      canBeCancelled: boolean;
      canBeMarkAsPaid: boolean;
      canBeRefunded: boolean;
      canBeCompleted: boolean;
      id: Guid;
      number: OrderNumber;
      status: OrderStatus;
      totalPrice: number;
      refundSummary?: Nillable<RefundSummary>;
      totalItems: number;
      createdAt: Date;
      comment?: Nillable<string>;
      owner?: Nillable<AdminOwner>;
      billingAddress: AdminOrderBillingAddress;
      items: AdminOrderItem[];
      payments: AdminOrderPayment[];
      shipments: AdminOrderShipment[];
      invoice?: Nillable<AdminOrderInvoice>;
      temporaryInvoice?: Nillable<AdminOrderInvoice>;
      paidAt?: Nillable<Date>;
      cancelledAt?: Nillable<Date>;
      completedAt?: Nillable<Date>;
      refundedAt?: Nillable<Date>;
      refunds: OrderRefundCollectionItem[];
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): OrderNumber {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get refundSummary(): Nillable<RefundSummary> {
    return this.data.refundSummary;
  }

  public get totalItems(): number {
    return this.data.totalItems;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get owner(): Nillable<AdminOwner> {
    return this.data.owner;
  }

  public get billingAddress(): AdminOrderBillingAddress {
    return this.data.billingAddress;
  }
  public get items(): AdminOrderItem[] {
    return this.data.items;
  }

  public get payments(): AdminOrderPayment[] {
    return this.data.payments;
  }

  public get shipments(): AdminOrderShipment[] {
    return this.data.shipments;
  }

  public get invoice(): Nillable<AdminOrderInvoice> {
    return this.data.invoice;
  }

  public get temporaryInvoice(): Nillable<AdminOrderInvoice> {
    return this.data.temporaryInvoice;
  }

  public get paidAt(): Nillable<Date> {
    return this.data.paidAt;
  }

  public get cancelledAt(): Nillable<Date> {
    return this.data.cancelledAt;
  }

  public get completedAt(): Nillable<Date> {
    return this.data.completedAt;
  }

  public get refundedAt(): Nillable<Date> {
    return this.data.refundedAt;
  }

  public get canBeCancelled(): boolean {
    return this.data.canBeCancelled;
  }

  public get canBeMarkAsPaid(): boolean {
    return this.data.canBeMarkAsPaid;
  }

  public get canBeRefunded(): boolean {
    return this.data.canBeRefunded;
  }

  public get canBeCompleted(): boolean {
    return this.data.canBeCompleted;
  }

  public get refunds(): OrderRefundCollectionItem[] {
    return this.data.refunds;
  }
}
